<template>
  <div class="card border-0 mb-3" v-if="question.user">
    <div class="card-body border-bottom p-0 mx-1">
      <router-link tag="h5" :to="{name: 'question',params: {slug: question.slug}}"
                   class="fz-12 text-left cursor-pointer text-green">
        {{ question.title }}
      </router-link>
      <div class="row align-items-end mx-0 pb-1 mt-n2">
        <div class="mr-auto font-weight-bold" v-if="question.user">
          <img :src="question.user.avatar" class="wh20x rounded-20" alt="avatar">
          <span class="fz-9 ml-1">{{ question.user.last_name }}</span>
        </div>
        <div class="ml-auto d-flex flex-column align-items-end">
          <span class="title fz-10 mb-1">
            {{ moment(question.created).format('DD/MM/Y') }}
          </span>
          <div class="cursor-pointer d-flex text-title">
            <span class="border-left pl-2">
              {{ question.responses !== undefined && question.responses !== null ? question.responses.length : 0 }} Rep
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'MiniQuestion',
  props: {
    question: {type: Object, default: null},
  },
  data() {
    return {}
  },
  methods: {
    moment,
  },
  computed: {
    ...mapGetters(['user']),
  },
  mounted() {
  }
}
</script>

<style lang="scss">
</style>

